"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactJsonView = _interopRequireDefault(require("react-json-view"));
var _reactComponents = require("@cimpress/react-components");
var _sharedClasses = require("../../constants/sharedClasses");
var _filterCaveats = require("../../helpers/filterCaveats");
var _AccordionWrapper = _interopRequireDefault(require("../AccordionWrapper"));
var _DisplayContext = require("../contexts/DisplayContext");
var _react2 = require("@emotion/react");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/* eslint-disable react/prop-types */

var columns = [{
  Header: 'Code',
  accessor: 'code',
  Cell: function Cell(_ref) {
    var value = _ref.value;
    return (0, _react2.jsx)("p", {
      style: {
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        lineHeight: '17.7px'
      }
    }, value);
  }
}, {
  Header: 'Message',
  accessor: 'message',
  Cell: function Cell(_ref2) {
    var value = _ref2.value,
      original = _ref2.original;
    var additionalInfo = (0, _omit2["default"])(original, ['code', 'message']);
    return (0, _react2.jsx)(_react["default"].Fragment, null, (0, _react2.jsx)("div", {
      style: {
        marginBottom: '5px',
        whiteSpace: 'normal',
        lineHeight: '17.7px'
      }
    }, value), !(0, _isEmpty2["default"])(additionalInfo) && (0, _react2.jsx)(_reactJsonView["default"], {
      style: {
        overflowX: 'scroll'
      },
      src: additionalInfo,
      name: false,
      indentWidth: 2,
      displayDataTypes: false,
      displayObjectSize: false,
      enableClipboard: false,
      collapsed: true
    }));
  }
}];
var CaveatsDisplay = function CaveatsDisplay(_ref3) {
  var caveats = _ref3.caveats;
  var _useContext = (0, _react.useContext)(_DisplayContext.DisplayContext),
    showCondensedView = _useContext.showCondensedView;
  var filteredCaveats = (0, _filterCaveats.filterCaveats)(caveats);
  return filteredCaveats.length > 0 && (!showCondensedView ? (0, _react2.jsx)(_AccordionWrapper["default"], {
    title: "Caveats",
    variant: "minimal"
  }, (0, _react2.jsx)(_reactComponents.ReactTablev6, {
    columns: columns,
    data: filteredCaveats,
    pageSize: filteredCaveats.length,
    showPagination: false,
    sortable: false,
    condensed: true
  })) : (0, _react2.jsx)("div", null, (0, _react2.jsx)("h4", {
    css: _sharedClasses.caveatsHeaderStyle
  }, "Caveats"), (0, _react2.jsx)(_reactComponents.ReactTablev6, {
    columns: columns,
    data: filteredCaveats,
    pageSize: filteredCaveats.length,
    showPagination: false,
    sortable: false,
    condensed: true
  })));
};
CaveatsDisplay.propTypes = {
  caveats: _propTypes["default"].arrayOf(_propTypes["default"].objectOf(_propTypes["default"].any)).isRequired
};
var _default = exports["default"] = CaveatsDisplay;